//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { SocialButtonService } from '~/utils/services/socialService'
import Facebook from '~/assets/icons/ico-facebook-f.svg'
import Twitter from '~/assets/icons/ico-twitter.svg'
import Whatsapp from '~/assets/icons/ico-whatsapp.svg'
import Email from '~/assets/icons/ico-email.svg'
import Sms from '~/assets/icons/ico-sms.svg'
import Messenger from '~/assets/icons/ico-messenger.svg'
import { isWindow } from '~/plugins/v-js'

const _service = new SocialButtonService()
export default {
  name: 'SocialButton',
  components: {
    Facebook, Twitter, Whatsapp, Email, Sms, Messenger
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    },
    boatId: {
      type: Number,
      default: 0
    },
    lang: {
      type: String,
      default: 'en'
    }
  },
  data () {
    return {
      linkUrl: '',
      copied: false
    }
  },
  mounted () {
    if (process.client) {
      this.$store.dispatch('auth/setAuthScript')
      this.linkUrl =
        'https://' +
        window.location.hostname +
        window.location.pathname +
        '?utm_medium=referral&utm_source=sharingbar'
    } else {
      this.linkUrl = ''
    }
    _service.setReferralLink(this.linkUrl, this.lang)
    /** this._service.animationState.subscribe((value) => {
      this.toolTipState = value;
    }); */
  },
  methods: {
    copyAnimation () {
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 5000)
    },
    socialCallback () {
      if (this.config.type === 'copylink') {
        this.showLinkInputField = true
      }
      setTimeout(() => {
        _service.triggerCallback(this.config.type)
      }, 100)

      if (isWindow()) {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'share',
          method: this.config.type,
          item_id: this.boatId.toString()
        })
      }
    }
  }
}
